export default {
      id: "report-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#report",
      toString: function () {
        return this.url;
      }
    }